import JustifiFormBaseController from "./justifi_form_base_controller";

export default class extends JustifiFormBaseController {
  static targets = [
    ...JustifiFormBaseController.targets,
    "justifiCreditCardForm",
    "creditCardForm",
    "addressStreet1",
    "addressStreet2",
    "addressCity",
    "addressState",
    "addressPostalCode",
    "addressCountry"
  ];

  static values = {
    address: Object,
    accessToken: String,
    accountId: String,
    entryMethod: String,
    customerId: Number,
    visitId: Number
  };

  getFormTarget() {
    return this.creditCardFormTarget;
  }

  async submitPaymentMethod(event) {
    event.preventDefault();
    this.clearError();

    if (!this.canSubmit()) {
      return;
    }

    try {
      const data = await this.tokenizePaymentMethod();
      this.processTokenizationResult(data);
    } catch (error) {
      this.handleTokenizationError(error);
    } finally {
      clearTimeout(this.timeoutId);
    }
  }

  canSubmit() {
    if (!this.startSubmission()) {
      return false;
    }

    if (!this.hasJustifiCreditCardFormTarget) {
      this.displayError("Credit card form component not found. Please refresh the page.");
      this.resetSubmission();
      return false;
    }

    return true;
  }

  async tokenizePaymentMethod() {
    const { accessTokenValue: accessToken, accountIdValue: accountId } = this;
    const paymentMethodData = {
      ...this.buildAddressData()
    };

    return await this.withTimeout(
      this.justifiCreditCardFormTarget.tokenize(accessToken, paymentMethodData, accountId),
      3000,
      'Tokenization timeout'
    );
  }

  processTokenizationResult(data) {
    if (data.error) {
      this.displayError(data.error.message || "Payment processing failed. Please try again.");
      this.notifyError(data.error);
      this.resetSubmission();
      return;
    }
    this.handleTokenizeResult(data);
  }

  handleTokenizationError(error) {
    if (error.message.includes('timeout')) {
      // Justifi component already shows validation errors
    } else {
      console.error("Tokenization error:", error);
      this.displayError("An unexpected error occurred. Please try again.");
    }
    this.resetSubmission();
  }

  // Helper: handle successful tokenization response
  handleTokenizeResult(data) {
    this.appendHiddenField("payment_method_id", data.id);
    this.appendHiddenField("entry_method", this.entryMethodValue || "justifi_credit_card_form");

    if (this.hasCreditCardFormTarget) {
      try {
        this.creditCardFormTarget.requestSubmit();
      } catch (error) {
        console.error("Form submission error:", error);
        this.displayError("Unable to submit form. Please refresh and try again.");
        this.resetSubmission();
      }
    } else {
      console.error("Credit card form target not found");
      this.displayError("Unable to submit form. Please refresh and try again.");
      this.resetSubmission();
    }
  }

  notifyError(error) {
    // Display error to user
    let errorMessage = "An error occurred. Please check your information and try again.";

    if (error.message) {
      errorMessage = error.message;
    }

    // Show error in UI
    this.displayError(errorMessage);

    // Call parent notifyError to handle Honeybadger logging
    super.notifyError(error);
  }
}
